<template>
  <div>
    <Header />
    <b-container class="mt-2">
      <b-row align-h="between">
        <b-col cols="5">
          <b-button variant="orange" class="w-100 py-3" disabled>{{ $ml.get('Já sou cadastrado') }}</b-button>
        </b-col>
        <b-col cols="5">
          <router-link to="/validate-info" class="w-100 btn btn-orange py-3" tag="button">{{ $ml.get('Faça seu cadastro') }}</router-link>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-5">
        <b-col cols="7">
          <h2 style="font-size: 2.3rem;" class="login-msg mt-3 mb-0">{{ $ml.get('INFORME USUÁRIO E SENHA PARA ENTRAR') }}</h2>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col cols="12" class="mt-3">
          <b-form @submit="login" autocomplete="off">
            <b-form-group>
              <v-keyboard id="input-username" v-model="username" :placeholder="$ml.get('Usuário')" :options="optionsLogin" autocomplete="off" :disableVirtualKeyboard="disableVirtualKeyboard" />
            </b-form-group>
            
            <b-form-group v-if="!fingerprintEnabled">
              <v-keyboard id="input-password" v-model="password" type="password" :placeholder="$ml.get('Senha')" :options="optionsPassword" :disableVirtualKeyboard="disableVirtualKeyboard" />
            </b-form-group>

            <b-row align-h="around" class="mt-5">
              <b-col cols="5" class="mt-3">
                <b-button type="submit" size="lg" variant="green" class="w-100">{{ $ml.get('Entrar') }}</b-button>
              </b-col>
              <b-col cols="5" class="mt-3">
                <router-link to="/change-password" class="w-100 btn btn-lg btn-brown" tag="button">{{ $ml.get('Esqueceu a senha?') }}</router-link>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

import api from '@/api'
import Swal from 'sweetalert2'
import SimpleKeyboard from '@/components/SimpleKeyboard'
import SimpleKeyboardTemplates from '@/components/SimpleKeyboardTemplates'
import { mapGetters } from 'vuex'
import Header from '../components/Header'


export default {
  name: 'login',
  components: { Header, 'v-keyboard': SimpleKeyboard },
  data () {
    return {
      optionsPassword: { ...SimpleKeyboardTemplates.password },
      optionsLogin: {...SimpleKeyboardTemplates.login },
      username: '',
      password: '',
      fingerprintEnabled: false
    }
  },
  mounted () {
    if (this.$socket && this.$socket.connected) {
      this.$socket.emit('getConfig', config => {
        if (config && config.fingerprint) {
          this.fingerprintEnabled = config.fingerprint
        }
      })
    }
  },
  methods: {    
    login (e) {
      e.preventDefault()
      if (!this.username) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: this.$ml.get('Digite o seu nome de usuário')
        })
        return
      }

      if (this.fingerprintEnabled) {
        return this.loginByFingerprint()
      } else {
        return this.loginByPassword()
      }
    },

    loginByPassword () {
      if (!this.password) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: this.$ml.get('Digite a senha')
        })
        return
      }

      Swal.fire({
        text: this.$ml.get('Autenticando'),
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading()
        }
      })

      api.authenticateUser(this.username, this.password).then(user => {
        // if (!user.person.validated_at) {
        //     Swal.fire({
        //       icon: 'error',
        //       title: 'Usuário não validado',
        //       text: 'Dirija-se até a recepção para validar o seu cadastro.'
        //     })
        //     this.username = ''
        //     this.password = ''
        //     return
        // }

        this.$store.commit('setUser', user)
        this.createUsage()

        if (user && user.person && user.person.units && !user.person.units.length) {
          // usuário sem unidade: associa-o a unidade do totem
          const userData = { person: { units: [this.unit.id] } }
          api.userRequest({
            url: `user/me`,
            method: 'put',
            data: userData
          }).then(r => {
            this.$store.commit('setUser', r.user)
          }).catch(e => {
            console.log('Erro ao atualizar unidade do usuário para a do Totem', e)
          })
        }
      }).catch(e => {
        let message = e

        if (e.message) {
          message = e.message
        }

        if (message === 'Network Error') {
          message = 'Erro de rede'
        }

        if (message === 'The user credentials were incorrect.') {
          message = this.$ml.get('As credenciais estão incorretas')
        }

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: message
        })
        this.password = ''
      })
    },

    loginByFingerprint () {
      let fingerprintImg = require(`@/assets/img/fingerprint.gif`)
      Swal.fire({
        html: `<h2>${this.$ml.get('Login com digital')}</h2><img src="${fingerprintImg}" />`,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: this.$ml.get('Cancelar'),
        allowOutsideClick: false,
        onOpen: () => {
          this.$socket.emit('capture', result => {
            Swal.close(result)
          })
        }
      }).then(result => {
        if (result.dismiss === "cancel") {
          this.$socket.emit('stop')
          return
        }

        if (result.code == 0 && result.fingerprint) {
          Swal.fire({
            text: this.$ml.get('Autenticando'),
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            }
          })

          api.authenticateUserByFingerprint(this.username, result.fingerprint).then(user => {
            this.$store.commit('setUser', user)
            this.createUsage()
          }).catch(e => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: e.message
            })
          })
        }

        if (result.code != 0) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: this.$ml.get('Não foi possível realizar a leitura da impressão digital'),
            footer: result.code ? `<small>${result.code}</small>` : ''
          })          
        }
      })
    },
    
    createUsage() {
      this.$store.dispatch('createTotemUsage')
      this.$router.push('/main')
      Swal.close()
    }
  },
  computed: {
    ...mapGetters({
      equipment: 'getEquipment',
      unit: 'getUnit',
      disableVirtualKeyboard: 'getDisableVirtualKeyboard',
    })
  }
}
</script>
